// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".cancel-btn[data-v-807bc976]{display:block;border:0;background-color:#01426b;color:#fff;border-radius:30px;padding:2px 10px;margin:10px auto 0}.app-loader__message[data-v-807bc976]{padding:20px 20px 0;font-size:18px;font-family:SFProDisplay-Bold,sans-serif;text-align:center}", ""]);
// Exports
module.exports = exports;
